import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { DealService } from 'app/services/deal.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  isAuthenticated = false;
  isScrolled = false;
  logoImagePath = 'assets/images/logo.png';
  isHomeRoute = true;
  showAuthOverlay = false;
  customerName: string = '';
  customerId: number = 0;
  categories: any[] = [];
  selectedCategory = '';
  showCategoryDropdown = false;
  isHovering = false;

  constructor(private router: Router, private authService: AuthService, private dealService: DealService) {
    this.customerId = Number(localStorage.getItem('customerId')) || 0;
     window.addEventListener('scroll', () => {
      this.isScrolled = window.scrollY > 0;
    });
  }

  ngOnInit(): void {
    // Handle authentication state changes
    this.authService.isAuthenticated$.subscribe((isAuth) => {
      this.isAuthenticated = isAuth;
    });

    this.authService.customer$.subscribe((customer) => {
      this.customerName =
        customer?.deliveryAddresses?.[0]?.contactName ||
        customer?.customerName ||
        customer?.customerEmail?.split('@')[0];
      ('');
    });

    this.getCategories();

    // Handle auth overlay visibility
    this.authService.showAuthOverlay$.subscribe(
      (isShowAuthOverLay) => (this.showAuthOverlay = isShowAuthOverLay)
    );

    // Handle initial route on component load
    this.checkIfHomeRoute(this.router.url);
    this.updateNavbarState();

    // Subscribe to route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.checkIfHomeRoute(event.url);
        this.updateNavbarState();

        if (this.isHomeRoute) {
          setTimeout(() => {
            this.updateNavbarState();
          }, 0);
        }
      });
  }

  public getCategories() {
    this.dealService.getDealCategoriesFromApi().subscribe((res: any) => {
      if (res.success && res.data) {
        const staticList = this.dealService.getDealCategories();
        this.categories = res.data.map((apiCat: any) => {
          const match = staticList.find(s => s.value === apiCat.category);
          return {
            value: apiCat.category,
            label: match ? match.label : apiCat.category,
            dealCount: apiCat.dealCount
          };
        });
      }
    });
  }

  onCategorySelect() {
    if (this.selectedCategory) {
      this.router.navigate(['/home'], {
        queryParams: { category: this.selectedCategory },
      });
    } else {
      this.router.navigate(['/home']);
    }
  }

  private getCustomerById(): void {
    if (this.isAuthenticated && this.customerId) {
      this.authService.getCustomerById(this.customerId).subscribe(
        (customer) => {
          const result = customer.result;
          if (result) {
            this.customerName =
              result.customerName ||
              (result.deliveryAddresses?.length > 0
                ? result.deliveryAddresses[0].contactName
                : '') ||
              '';
          }
        },
        (error) => {
          console.error('Error fetching customer details:', error);
        }
      );
    }
  }

  private checkIfHomeRoute(url: string): void {
    this.isHomeRoute = url === '/' || url === '/home';
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Only apply scroll effect on home route
    if (this.isHomeRoute) {
      this.isScrolled = window.scrollY > 50;
    } else {
      // Always show solid navbar on non-home routes
      this.isScrolled = true;
    }
  }

  // Force a check of scroll state when route changes
  private updateNavbarState(): void {
    if (this.isHomeRoute) {
      this.isScrolled = window.scrollY > 50;
    } else {
      this.isScrolled = true;
    }
  }

  openUserProfile() {
    if (!this.isAuthenticated) {
      this.authService.showAuthOverlay(true);
    } else {
      this.router.navigate(['/profile']);
    }
  }

  closeAuthOverlay() {
    this.showAuthOverlay = false;
  }

  toggleCategoryDropdown() {
    this.showCategoryDropdown = !this.showCategoryDropdown;
  }

selectCategory(categoryValue: string) {
  this.router.navigate(['/home'], { queryParams: { category: categoryValue } });
   this.showCategoryDropdown = false; // close after click
}

}
